<template>
  <el-dialog  :title="title" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="moneyDialog " width="600px" center>
      <div>
      <el-form  :inline="true"  :model="moneyfrom" ref="moneyfrom" :rules="rules" class="demo-form-inline inpBox jiaoyan"  label-width="220px"  size="mini"  >
        <div v-if="moneyFlag==1">
          <el-form-item label="修改项目:" prop="modifyItem"   >
            <el-select  v-model="moneyfrom.modifyItem"  placeholder="请选择" @change="changeModifyItem">
              <el-option  label="收入附加" value="收入附加" ></el-option>
              <el-option  label="收入计价" v-if="!rowData.isZhanbao" value="收入计价" ></el-option>
              <el-option  label="结算客户" value="结算客户" ></el-option>
              <el-option  label="是否一票制" value="是否一票制" ></el-option>
              <el-option  label="是否开票" value="是否开票" ></el-option>
              <el-option  label="收入方式" value="收入方式" ></el-option>
            </el-select>
          </el-form-item>
          <div v-if="moneyfrom.modifyItem=='收入附加'">
            <!-- <el-form-item label="修改类型:" prop="modifyType"   >
              <el-select  v-model="moneyfrom.modifyType"  placeholder="请选择">
                <el-option  label="增项" value="0" ></el-option>
                <el-option  label="减项" value="1" ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="附加金额(元):" class="jiage" prop="revenueSurcharge" >
              <el-input  placeholder=""   oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"  maxlength="8"
              v-model="moneyfrom.revenueSurcharge"  ></el-input><span class="danwei">元</span>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='收入计价'">
            <el-form-item label="修改后收入计价" prop="revenueValuation"   >
              <el-select  v-model="moneyfrom.revenueValuation"  placeholder="请选择" @change="jijiaChange">
                 <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(rowData.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>&nbsp;&nbsp;
              <el-checkbox v-model="isSG" v-if="moneyfrom.revenueValuationName=='按吨'">首钢价格</el-checkbox>
            </el-form-item>
            <el-form-item label="选择模板" prop="month"  v-if="isSG" >
                <el-date-picker
                  v-model="moneyfrom.month"
                  type="month"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="选择年月">
                </el-date-picker>
            </el-form-item>
            <div v-else>
              <el-form-item label="修改后收入单价(元/吨/方/件)"  prop="incomeUnitPrice"  v-if="moneyfrom.revenueValuation!=1" >
                <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="moneyfrom.incomeUnitPrice"  ></el-input>
              </el-form-item>
              <el-form-item label="修改后收入金额(元)"  prop="incomeAmount"   v-else>
                <el-input  placeholder=""  v-number-input.float="2"   maxlength="10" v-model="moneyfrom.incomeAmount"  ></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if="moneyfrom.modifyItem=='结算客户'">
            <el-form-item label="结算客户 :" prop="payee" >
              <el-select  v-model="moneyfrom.payee" filterable placeholder="请选择" @change="jiesuanChange">
                <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='是否一票制'">
            <el-form-item label="是否一票制:"  >
              <template >
                <el-radio-group v-model="moneyfrom.ticketSystemYn"   >
                  <el-radio label="是">是</el-radio>
                  <el-radio label="否">否</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='是否开票'">
            <el-form-item label="是否开票:"  >
              <template >
                <el-radio-group v-model="moneyfrom.makeTicketYn"   >
                  <el-radio label="是">是</el-radio>
                  <el-radio label="否">否</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='收入方式'">
            <el-form-item label="收入方式:"  prop="incomePattern" >
              <el-select  v-model="moneyfrom.incomePattern"  placeholder="请选择" @change="srfsChange">
                 <template  v-for="item in SRFSlist">
                     <el-option  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="收入备注"  prop="incomeRemark">
            <el-input  placeholder=""   maxlength="50" v-model.trim="moneyfrom.incomeRemark"  ></el-input>
          </el-form-item>
        </div>
        <div v-if="moneyFlag==2">
          <el-form-item label="修改项目:" prop="modifyItem"  >
            <el-select  v-model="moneyfrom.modifyItem"  placeholder="请选择">
              <el-option  label="支出附加" v-if="!rowData.isFS||rowData.onlinePushFlag!=1" value="支出附加" ></el-option>
              <el-option  label="服务费率" v-if="rowData.onlinePushFlag!=1"  value="服务费率" ></el-option>
              <el-option  label="运费计价" v-if="!rowData.whqsFlag" value="运费计价" ></el-option>
              <el-option  label="收款方"   v-if="rowData.onlinePushFlag!=1" value="收款方" ></el-option>
              <el-option  label="支出方式" value="支出方式" ></el-option>
            </el-select>
          </el-form-item>
          <div v-if="moneyfrom.modifyItem=='支出附加'">
            <!-- <el-form-item label="修改类型:" prop="modifyType"   >
              <el-select  v-model="moneyfrom.modifyType"  placeholder="请选择">
                <el-option  label="增项" value="0" ></el-option>
                <el-option  label="减项" value="1" ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="附加金额(元):" class="jiage" prop="disburseSurcharge" >
              <el-input  placeholder=""  oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"  maxlength="8"
               v-model="moneyfrom.disburseSurcharge"  ></el-input><span class="danwei">元</span>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='服务费率'">
            <el-form-item label="修改后服务费率(%):" class="jiage" prop="serviceRate" >
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="moneyfrom.serviceRate"  ></el-input><span class="danwei">%</span>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='运费计价'">
            <el-form-item label="修改后运费计价(元):"  prop="freightPricingType" >
              <el-select  v-model="moneyfrom.freightPricingType"  placeholder="请选择" @change="jijiaChange1">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(rowData.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="修改后运费单价(元/吨/方/件)"  prop="freightUnitPrice"  v-if="moneyfrom.freightPricingType!=1" >
              <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="moneyfrom.freightUnitPrice"  ></el-input>
            </el-form-item>
            <el-form-item label="修改后运费金额(元)"  prop="freightAmount"   v-else>
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="10" v-model="moneyfrom.freightAmount"  ></el-input>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='收款方'">
            <el-form-item label="收款类型"  prop="collectionType" >
              <template >
                <el-radio-group v-model="moneyfrom.collectionType"  @change="collectionTypeFn" >
                  <el-radio :label="1" >企业</el-radio>
                  <el-radio :label="2">司机</el-radio>
                  <el-radio :label="3">车队长</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="收款方:" prop="payer" :rules="[{ required: true, message: '请选择收款方', trigger: 'blur' }]" class="width1" v-if="moneyfrom.collectionType==1">
              <el-select  v-model="moneyfrom.payer" filterable placeholder="请选择"  @change="payerChange">
                <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推送网货:" v-if="moneyfrom.onlineFlag==1">
              <div> 否</div>
            </el-form-item>
            <br>
            <el-form-item label="服务费计算:" v-if="moneyfrom.collectionType==1&&moneyfrom.generalCarrier">
              <div> {{['正算','反算'][moneyfrom.reverseCountFlag]}}</div>
            </el-form-item>
            <!-- <el-form-item label="收款方:"  v-if="moneyfrom.collectionType==2">
              {{rowData.driverName}}
            </el-form-item> -->
            <el-form-item label="车队长姓名:"  prop="payer"  v-if="moneyfrom.collectionType==3">
              <!-- <el-input  placeholder=""    maxlength="50" v-model="moneyfrom.payer"  ></el-input> -->
              <el-autocomplete class="inline-input" v-model.trim="moneyfrom.payer"
                  :fetch-suggestions="querySearch" value-key="payerTaxId" @select="handleSelect" popper-class="xiala">
                    <template slot-scope="{ item }">
                        <div style="position: relative;">
                        <div class="name">{{ item.payer }} / {{ item.payerTaxId? item.payerTaxId:''}}</div>
                      </div>
                  </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="身份证号:" prop="payerTaxId"  v-if="moneyfrom.collectionType==3">
              <el-input  placeholder=""    maxlength="50" v-model="moneyfrom.payerTaxId"  ></el-input>
            </el-form-item>
          </div>
          <div v-if="moneyfrom.modifyItem=='支出方式'">
             <el-form-item label="支出方式"    class="table_error" prop="expenditurePattern" >
              <el-select  v-model="moneyfrom.expenditurePattern"  placeholder="请选择"  @change="zcfsChange">
                <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="支出备注"  prop="freightRemark ">
            <el-input  placeholder=""   maxlength="50" v-model.trim="moneyfrom.freightRemark "  ></el-input>
          </el-form-item>
        </div>
        <div v-if="moneyFlag==3">
          <el-form-item label="修改项目:" prop="modifyItem"   >
            <el-select  v-model="moneyfrom.modifyItem"  placeholder="请选择">
              <el-option  label="仓储费单价" value="仓储费单价" ></el-option>
              <el-option  label="仓储费金额" value="仓储费金额" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改后仓储费单价(元/吨/方/件)"  prop="storageUnitPrice" v-if="moneyfrom.modifyItem=='仓储费单价'" >
              <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="moneyfrom.storageUnitPrice"  ></el-input>
            </el-form-item>
          <el-form-item label="修改后仓储费金额(元)"  prop="storageCharges"  v-else>
            <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="moneyfrom.storageCharges"  ></el-input>
          </el-form-item>
        </div>

      </el-form>
      </div>
       <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveFn">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import { getDictionaryDetailList, findCustomerInfoList, updateWayIncome, updateWayFreight, updateWayStorageCharges,
  findVehicleLeaderList } from '@/api/newTMS'
import { selectTMSTenantListByCustom } from '@/api/newCrm'
export default {
  name: 'zhuagnxiepingzheng',
  props: {
    moneyDialog: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      moneyfrom: {
        wayBusinessIds: this.rowData.wayBusinessIds,
        collectionType: this.rowData.collectionType

      },
      moneyFlag: this.rowData.moneyFlag,
      title: this.rowData.title,
      rules: {
        modifyItem: [
          { required: true, message: '请选择修改项目', trigger: 'blur' }
        ],
        modifyType: [
          { required: true, message: '请选择修改类型', trigger: 'blur' }
        ],
        revenueSurcharge: [
          { required: true, message: '请输入附加金额', trigger: 'blur' }
        ],
        revenueValuation: [
          { required: true, message: '请选择收入计价', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        storageUnitPrice: [
          { required: true, message: '请输入仓储费单价', trigger: 'blur' }
        ],
        storageCharges: [
          { required: true, message: '请输入仓储费金额', trigger: 'blur' }
        ],
        disburseSurcharge: [
          { required: true, message: '请输入附加金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        freightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入收款方', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入收款方身份证号', trigger: 'blur' }
        ],
        collectionType: [
          { required: true, message: '请选择收款方类型', trigger: 'blur' }
        ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        month: [
          { required: true, message: '请选择年月', trigger: 'blur' }
        ],
        incomePattern: [
          { required: true, message: '请选择收入方式', trigger: 'blur' }
        ]
      },
      SRJJlist: [],
      kehuList: [],
      CYSList: [],
      SRFSlist: [],
      ZHFSlist: [],
      isSG: false
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    console.log(this.rowData.isZhanbao)
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    getDictionaryDetailList({ dictionaryType: 'up_settlement_type' }).then(res => { this.SRFSlist = res })
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })
    findCustomerInfoList({ businessType: 1 }).then(res => {
      selectTMSTenantListByCustom(res).then(res1 => { this.kehuList = res1 })
    })
    findCustomerInfoList({ businessType: 2 }).then(res => {
      selectTMSTenantListByCustom(res).then(res1 => { this.CYSList = res1 })
    })
    if (this.rowData.onlinePushFlag == 1 && this.moneyFlag == 2) {
      // this.$set(this.moneyfrom, 'modifyItem', '运费计价')
    }
  },
  methods: {
    // 支出方式修改
    zcfsChange (e) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      this.moneyfrom.expenditurePatternName = json[0].showName
    },
    // 收入方式更改
    srfsChange (e) {
      let json = this.SRFSlist.filter(item => item.itemNo == e)
      this.moneyfrom.incomePatternName = json[0].showName
    },
    // 收入的修改项目更改
    changeModifyItem (e) {
      if (e == '是否一票制') {
        this.$set(this.moneyfrom, 'ticketSystemYn', '否')
      }
      if (e == '是否开票') {
        this.$set(this.moneyfrom, 'makeTicketYn', '是')
      }
    },
    querySearch (str, cb) {
      findVehicleLeaderList({ payer: str }).then(res => {
        cb(res)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    handleSelect (row) {
      this.$set(this.moneyfrom, 'payer', row.payer)
      this.$set(this.moneyfrom, 'payerTaxId', row.payerTaxId)
    },
    // 收款方类型改变
    collectionTypeFn () {
      this.$set(this.moneyfrom, 'payer', '')
      this.$set(this.moneyfrom, 'payerTaxId', '')
      this.$set(this.moneyfrom, 'payerCode', '')
    },
    // 收款方改变
    payerChange (e) {
      let json = this.CYSList.filter(item => item.customerName == this.moneyfrom.payer)
      this.moneyfrom.payerTaxId = json[0].customerTaxId
      this.moneyfrom.payerCode = json[0].tenantCode
      this.moneyfrom.generalCarrier = json[0].customerName
      this.moneyfrom.generalTaxId = json[0].customerTaxId
      this.moneyfrom.generalCode = json[0].tenantCode
      this.moneyfrom.generalPeriodDays = json[0].periodDays
      this.moneyfrom.generalInvoiceDays = json[0].invoiceDays
      this.moneyfrom.generalPeriodDaysType = json[0].periodDaysType
      this.$set(this.moneyfrom, 'onlineFreightFlag', json[0].onlineFreightFlag)
      this.$set(this.moneyfrom, 'reverseCountFlag', json[0].reverseCountFlag)
      this.$set(this.moneyfrom, 'onlineFlag', json[0].onlineFlag)
      this.$set(this.moneyfrom, 'freightTaxRate', json[0].taxRate)
    },
    // 收入计价改变
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.moneyfrom.revenueValuationName = json[0].showName
      if (this.moneyfrom.revenueValuation == 1) {
        this.$set(this.moneyfrom, 'incomeUnitPrice', '')
        this.$set(this.moneyfrom, 'incomeAmount', '')
        this.isSG = false
      } else {
        this.$set(this.moneyfrom, 'incomeUnitPrice', '')
        this.$set(this.moneyfrom, 'incomeAmount', '')
      }
    },
    // 运费计价改变
    jijiaChange1 (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.moneyfrom.freightPricingTypeName = json[0].showName
      if (this.moneyfrom.freightPricingType == 1) {
        this.$set(this.moneyfrom, 'freightUnitPrice', '')
        this.$set(this.moneyfrom, 'freightAmount', '')
      } else {
        this.$set(this.moneyfrom, 'freightUnitPrice', '')
        this.$set(this.moneyfrom, 'freightAmount', '')
      }
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.moneyfrom.payee)
      this.moneyfrom.payCustomerId = json[0].id
      this.moneyfrom.payeeTaxId = json[0].customerTaxId
      this.moneyfrom.payeeCode = json[0].tenantCode
      this.moneyfrom.periodDays = json[0].periodDays
      this.moneyfrom.periodDaysType = json[0].periodDaysType
    },
    saveFn () {
      this.$refs.moneyfrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.moneyFlag == 1) { // 修改收入
            if (this.moneyfrom.modifyItem == '收入计价') {
              if (this.isSG) {
                this.$set(this.moneyfrom, 'modifyItem', '收入计价首钢')
                this.$set(this.moneyfrom, 'incomeUnitPrice', '')
                this.$set(this.moneyfrom, 'incomeAmount', '')
              } else {
                this.$set(this.moneyfrom, 'month', null)
              }
            }
            this.$set(this.moneyfrom, 'incomeRemark', this.moneyfrom.incomeRemark ? this.moneyfrom.incomeRemark : null)
            updateWayIncome(this.moneyfrom).then(res => {
              loading.close()
              this.$emit('update:moneyDialog', false)
              this.$parent.searchFn()
            }).catch(error => {
              if (this.moneyfrom.modifyItem == '收入计价首钢') {
                this.$set(this.moneyfrom, 'modifyItem', '收入计价')
              }
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else if (this.moneyFlag == 2) {
            this.$set(this.moneyfrom, 'freightRemark', this.moneyfrom.freightRemark ? this.moneyfrom.freightRemark : null)
            updateWayFreight(this.moneyfrom).then(res => {
              loading.close()
              this.$emit('update:moneyDialog', false)
              this.$parent.searchFn()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            updateWayStorageCharges(this.moneyfrom).then(res => {
              loading.close()
              this.$emit('update:moneyDialog', false)
              this.$parent.searchFn()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    closeDialog () {
      this.$emit('update:moneyDialog', false)
    }

  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.is-disabled .el-input__inner {
    background: #eff0f1;
}
  /deep/.el-input__inner{
  width:200px;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}
</style>
